<template>
  <div v-editable="blok" :class="rootClasses" :style="rootStyle">
    <div class="blok-container" >
        <div :class="summaryBlockClasses">
            <component :blok="child" :is="child.component" :key="index" v-for="(child,index) in blok.content"></component>
        </div>
    </div>
  </div>
</template>
<script>
import HeadingSection from "./HeadingSection.vue";
import TextBlok from "./TextBlok.vue";
import SummaryCard from './SummaryCard.vue';

export default {
  name: "summary-blok",
  props: {
    blok: Object
  },
  components: {
    HeadingSection,
    TextBlok,
    SummaryCard
  },
  computed: {
    rootClasses: function() {
      const b = this.$props.blok;
      return [
        "blok",
        b.contain ? "contained" : "",
      ];
    },
    summaryBlockClasses: function() {
        const b = this.$props.blok;
      return [
        "summary-blok",
        b.width,
        b.layout,
        b.text_styles.join(' '),
        b.image_styles.join(' '),
        b.class_overrides
      ];
    },
    rootStyle: function() {
      return {
        backgroundImage: `url(${this.blok.image})`
      };
    }
  }
};
</script>

